module.exports = "pegasus/assets/themelp1/basic/100.png";